/* eslint-disable no-undef */

export const clientId = process.env.https://radar_upload_frontend;
export const authAPI = process.env.https://radar-base.plri.de/managementportal/oauth;
export const authCallback = process.env.radar-base.plri.de/upload/login;
export const baseURL = process.env.https://radar-base.plri.de/upload/api/;

export default {
  clientId,
  authAPI,
  authCallback,
  baseURL,
};
